import googleSvg from "../../images/Google.svg";
import {
  useCreateUserWithEmailAndPassword,
  useSignInWithEmailAndPassword,
  useSignInWithGoogle,
  useSignOut
} from "react-firebase-hooks/auth";
import { auth, functions } from "../../firebase/config";
import { useAuthStore } from "../../stores/Auth.store";
import { useUsers } from "../collections/useUsers";
import { useNavigate } from "react-router-dom";
import { UserTypeEnum } from "../../@core/enums/UserType.enum";

export const useAuth = () => {
  const setAuth = useAuthStore((state) => state.setAuth);
  const { createAccount } = useUsers({ loadData: false });
  const [signInWithEmailAndPassword, , , errorSignIn] = useSignInWithEmailAndPassword(auth);
  const [signOut] = useSignOut(auth);
  const [signInWithGoogle] = useSignInWithGoogle(auth);
  const [createUserWithEmailAndPassword, , , errorCreateUser] = useCreateUserWithEmailAndPassword(auth);
  const navigate = useNavigate();

  const handleAuthentication = async (authData: any, otherFields?: any) => {
    setAuth(authData.user.uid);

    await createAccount(authData.user.uid, {
      imageUrl: authData.user.photoURL,
      email: authData.user.email,
      name: authData.user.displayName || otherFields.name,
      trash: false,
      createdAt: Date.now(),
      role: UserTypeEnum.USER
    });

    const setClaimsFunction = functions.httpsCallable("api/user/set-claims/" + authData.user.uid);

    await setClaimsFunction({
      data: {
        role: 'user' //TODO: create role enum
      }
    });

    navigate("/account");
  };

  const handleSignOut = async () => {
    try {
      navigate("/");
      await signOut();
    } catch (error) {
      console.error("Error signing out:", error);
    }
  };

  const handleGoogleSignIn = async () => {
    try {
      const newAuthentication = await signInWithGoogle();
      if (!newAuthentication) return;
      await handleAuthentication(newAuthentication);
      navigate("/account");
    } catch (error) {
      console.error("Error signing in with Google:", error);
    }
  };

  const socials = [
    {
      name: "Continue with Google",
      href: "#",
      icon: googleSvg,
      onClick: handleGoogleSignIn
    }
  ];

  return {
    handleAuthentication,
    socials,
    signInWithEmailAndPassword,
    errorCreateUser,
    errorSignIn,
    handleSignOut,
    createUserWithEmailAndPassword

  };
};
